<footer class="footer">
    <div class="description-text">&copy; 2025 {{companyName}} | All rights reserved</div>
</footer>